import { createSlice } from '@reduxjs/toolkit';
import { apiFetch } from '../utils';

const sessionSlice = createSlice({
    name: 'session',
    initialState: { user: null },
    reducers: {
        setUser: (state, action) => {
          state.user = action.payload;
        },
    },
});

export const restoreUser = () => async (dispatch) => {
  const response = await apiFetch('/auth/', 'GET');

  if (response?.code === 'success' && response.data) {
    dispatch(setUser(response.data));
    return response.data;
  }

  dispatch(setUser(null));
  return null;
};

export const { setUser } = sessionSlice.actions;
export default sessionSlice.reducer;